document.addEventListener('DOMContentLoaded', function() {
    // Warte auf Klicks im gesamten Dokument
    document.addEventListener('click', function(event) {
        // Prüfe, ob der Klick auf einen Link innerhalb des Navigations-Blocks erfolgte
        const navLink = event.target.closest('.wp-block-navigation-item__content');

        if (navLink) {
            // Suche den aktiven "Schließen"-Button des Overlays
            const closeButton = document.querySelector('.wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation__responsive-container-close');

            if (closeButton) {
                // Kurze Verzögerung, damit der Anker-Sprung sauber eingeleitet wird
                setTimeout(() => {
                    closeButton.click();
                }, 100);
            }
        }
    });
});